export default [
    {
        path: '/bank',
        name: 'bank',
        component: () => import('@/views/menu/wallet/bank.vue'),
        meta: {
            pageTitle: 'مدیریت بانک‌ها',
            action: 'show',
            resource: 'BankManager',
        },
    },
    {
        path: '/withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/menu/wallet/withdrawal.vue'),
        meta: {
            pageTitle: 'درخواست‌های برداشت',
            action: 'show',
            resource: 'WithdrawalManager',
        },
    },
    {
        path: '/wallet',
        name: 'wallet',
        component: () => import('@/views/menu/wallet/wallet.vue'),
        meta: {
            pageTitle: 'کیف‌پول کاربران',
            action: 'show',
            resource: 'WithdrawalManager',
        },
    },
    {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/menu/wallet/payment.vue'),
        meta: {
            pageTitle: 'پرداخت‌های درگاه',
            action: 'show',
            resource: 'PaymentManager',
        },
    },
]
